import { TooltipV2 } from '@cimplico/components';
import { calcRelativeTime, formatDateTime } from '../utilities/formatting';

type RelativeTimestampProps = {
    /**
     * Date to format
     */
    date?: Date | string | null;
    /**
     * Optional text styles
     */
    className?: string;
    /**
     * Optional prefix to add to the timestamp
     */
    prefix?: string;
};

/**
 * Helpful wrapper function to automatically format a timestamp relative to the current date.
 * A tooltip is also added to show the absolute date.
 *
 * A prefix can be provided to add a label to the timestamp.
 *
 * __NOTE__: No styling is applied, it's up to you to style the text.
 * @example label: '3 days ago' hover: 6 Sep, 2024 at 8:32 am
 *
 * @param RelativeTimestampProps
 * @returns
 */
function RelativeTimestamp({ date, className, prefix }: RelativeTimestampProps): JSX.Element {
    if (!date) {
        return <></>;
    }
    return (
        <div className={`w-fit ${className}`}>
            <TooltipV2 message={date ? formatDateTime(date) : ''} disabled={!date}>
                <span>
                    {prefix ? `${prefix} ` : ''}
                    {date ? calcRelativeTime(date) : '-'}
                </span>
            </TooltipV2>
        </div>
    );
}

export default RelativeTimestamp;
